import { render } from "./QimenPalaceWithFormation.vue?vue&type=template&id=4cd24e78"
import script from "./QimenPalaceWithFormation.vue?vue&type=script&lang=js"
export * from "./QimenPalaceWithFormation.vue?vue&type=script&lang=js"

import "./QimenPalaceWithFormation.vue?vue&type=style&index=0&id=4cd24e78&lang=css"

import exportComponent from "/Users/jinming/Documents/jhapps/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__